export type AppRole = 'superadmin' | 'business' | 'customer';

export const APP_ROLES: AppRole[] = ['superadmin', 'business', 'customer'];

export function isAppRole(value: unknown): value is AppRole {
  return typeof value === 'string' && APP_ROLES.includes(value as AppRole);
}